// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import {Guid} from "guid-typescript";

// AbilityIntranet.Data.Intranet.EntityBaseDto
export class EntityBaseDto {
    public guid: Guid = null;
    public rowId: number = 0;
    public rowVersion: number = 0;
    public timeInserted: Date = new Date(0);
    public insertedBy: string = null;
    public timeUpdated: Date = null;
    public updatedBy: string = null;
    public timeDeleted: Date = null;
    public deletedBy: string = null;
    public isDeleted: boolean = false;
}


    



